import { Directive, ElementRef, HostListener } from '@angular/core';
import { AppAbstractDirective } from './appAbstractDirective';

@Directive({
  selector: '[appTableInputFilter]'
})
export class AppTableInputFilterDirective extends AppAbstractDirective  {

  constructor(private element: ElementRef) {
    super();
  }

  @HostListener('focus', ['$event.target']) focus(): void {
    (this.element.nativeElement as HTMLInputElement).select();
  }
  @HostListener('input') onInput(): void {
    this.element.nativeElement.value = this.element.nativeElement.value.toUpperCase();
  }

}
